define("shared/utils/state-list", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.UnitedStatesStateISOCode = _exports.CountryToStateMap = _exports.CanadaProvinceISOCode = void 0;
  _exports.isCountryWithStateOptions = isCountryWithStateOptions;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  // ISO 3166-2 governs this list.
  // https://www.iso.org/obp/ui/#iso:code:3166:CA
  const CanadaProvinceISOCode = _exports.CanadaProvinceISOCode = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

  // ISO 3166-2 governs this list.
  // https://www.iso.org/obp/ui/#iso:code:3166:US
  const UnitedStatesStateISOCode = _exports.UnitedStatesStateISOCode = ['AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MP', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'];
  const CountryToStateMap = _exports.CountryToStateMap = {
    CA: CanadaProvinceISOCode,
    US: UnitedStatesStateISOCode
  };
  function isCountryWithStateOptions(key) {
    return key in CountryToStateMap;
  }
  const getStateList = intl => {
    const options = Object.entries(CountryToStateMap).reduce((acc, _ref) => {
      let [country, states] = _ref;
      acc[country] = states.map(state => ({
        value: state,
        name: intl.t(`address.state_field_options.${country}.${state}`)
      })).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      return acc;
    }, {});
    return options;
  };
  var _default = _exports.default = getStateList;
});